export default __webpack_public_path__ + "static/media/bold_brave.1956b55d.png";